<!-- 订单详情页面-单一产品成本预估下载模块 -->
<template>
  <div class="modelMain" v-loading.fullscreen.lock="loading">
    <div class="jsb acenter">
      <div class="fontLeft">
        <!-- 订单详情 -->
        <h3 class="modelTitle">{{ $fanyi("订单详情") }}</h3>
        <p class="blue">
          <!-- 1. [单品费用]该明细表详细计算了各商品采用不同运输方式运抵目的地的成本。(Rakumart负责全程清关及配送。) -->
          {{
            $fanyi(
              "1. [单品费用]该明细表详细计算了各商品采用不同运输方式运抵目的地的成本。(Rakumart负责全程清关及配送。)"
            )
          }}
        </p>
        <p class="yellow">
          <!-- 2. [更多信息]此外，表格列明了供应商提供的各商品尺寸和重量，便于您掌握订单详情。 -->
          {{
            $fanyi(
              "2. [更多信息]此外，表格列明了供应商提供的各商品尺寸和重量，便于您掌握订单详情。"
            )
          }}
        </p>
        <p class="green">
          <!-- 3. 点击按钮即可下载明细表。 -->
          {{ $fanyi("3. 点击按钮即可下载明细表。") }}
        </p>
        <el-button class="bgBlueBtn downloadBtn" @click="goDownLoad">
          <span class="dip"
            >{{ $fanyi("商品进口成本预估") }} <i class="el-icon-download"></i
          ></span>
        </el-button>
      </div>
      <div>
        <div class="imageRight">
          <img
            width="541px"
            src="https://rakumart-test.oss-cn-hangzhou.aliyuncs.com/202503/67cbd5769441b.png"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import urlHead from "@/api/wangZhi.js";
export default {
  data() {
    return {
      loading: false,
    };
  },
  components: {},
  computed: {},
  created() {},
  methods: {
    goDownLoad() {
      this.loading = true;
      this.$api
        .downloadCostAnalysis({
          order_sn: this.$route.query.order_sn,
        })
        .then((res) => {
          let url = res.data;
          this.loading = false;
          let a = document.createElement("a");
          a.target = "_blank";
          a.href = url;

          a.click();
          document.removeChild(a);
        });
    },
  },
};
</script>
<style lang="scss" scoped="scoped">
@import "@/css/mixin.scss";
.modelMain {
  width: $pageWidth;
  height: 435px;
  background: #ffffff;
  border-radius: 16px;
  border: 1px solid #e1e1e1;
  padding: 42px 30px 42px 60px;
  margin: 0 auto;
  color: #2f2f2f;
  .modelTitle {
    line-height: 1;
    font-weight: 600;
    font-size: 18px;
    margin-bottom: 8px;
  }
  .fontLeft {
    @extend .fdcolmun;
    gap: 22px;
    margin-right: 65px;
    p {
      line-height: 25px;
      font-size: 16px;
      min-height: 42px;
      @extend .acenter;
      background-color: transparent !important;
      &::before {
        margin-right: 20px;
        content: " ";
        width: 2px;
        flex: 0 0 2px;
        height: 42px;
      }
    }
    .blue {
      &::before {
        background-color: #009246;
      }
    }
    .yellow {
      &::before {
        background-color: #ffa200;
      }
    }
    .green {
      &::before {
        background-color: #009246;
      }
    }
    .bgBlueBtn {
      padding: 0 40px;
      height: 60px;
      border-radius: 12px;
      border-width: 2px;
      margin-top: 5px;
      width: max-content;
    }
    .downloadBtn {
      i {
        font-size: 20px;
        margin-left: 10px;
      }
    }
  }
}
</style>
